import {
  endOfYear,
  format,
  formatDistanceToNow,
  getDate,
  getMonth,
  getTime,
  getYear,
  startOfYear,
} from 'date-fns';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function fToMMDD(date: InputValue) {
  return date ? format(new Date(date), 'MM/dd') : '';
}
export function fToMMDDYY(date: InputValue) {
  return date ? format(new Date(date), 'MM/dd/yy') : '';
}

export const getYearDates = (year: number): { yearStartDate: string; yearEndDate: string } => {
  const startDate = startOfYear(new Date(year, 0, 1));
  const endDate = endOfYear(new Date(year, 11, 31));

  const dateFormat = 'MM/dd/yyyy';

  return {
    yearStartDate: format(startDate, dateFormat),
    yearEndDate: format(endDate, dateFormat),
  };
};

export function convertDateToUTC(date: Date | null) {
  if (!date) return new Date();
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}
export function removeTime(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function getCurrentMonth() {
  const currentDate = new Date();
  return getMonth(currentDate) + 1;
}
export function getCurrentDate() {
  const currentDate = new Date();
  return getDate(currentDate);
}

export function getCurrentYear() {
  const currentDate = new Date();
  return getYear(currentDate);
}

export const convertToDate = (date: InputValue) => {
  const dateFormat = 'MM/dd/yyyy';
  return date ? format(new Date(date), dateFormat) : '';
};
export function validateDateFormat(date: string) {
  return (
    (date?.includes('month') && date?.includes('day') && date?.includes('year')) ||
    (!date?.includes('month') && !date?.includes('day') && !date?.includes('year'))
  );
}

export function isYearBetween(yearToCheck: number, startYear: number, endYear: number) {
  return yearToCheck >= startYear && yearToCheck <= endYear;
}
export function isPastYear(endYear: number) {
  return getCurrentYear() > endYear;
}
export function isCurrentYear(endYear: number) {
  return getCurrentYear() === endYear;
}
export function isFutureYear(endYear: number) {
  return getCurrentYear() < endYear;
}

export function isValidDate(dateString: number | string | Date) {
  const date = new Date(dateString);
  return dateString ? !isNaN(date.getTime()) : false;
}
